export default "__VITE_ASSET__AmFjY74q__"